<!--
 * @Author: cryi.liu
 * @Date: 2020-05-09 09:46:46
 * @LastEditTime: 2020-05-25 15:08:46
 * @Description: 生成试卷数据表格
 -->
<template>
  <div class="generate-test-paper-data-table">
    <i-table :columns="columns" :data="data" border :max-height="420" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GenerateTestPaperDataTable',
  data() {
    return {
      columns: [],
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      questionComplete: 'createPaperStore/questionComplete',
    }),
  },
  watch: {
    questionComplete() {
      this.setColumns();
      this.setData();
    },
  },
  methods: {
    setColumns() {
      this.columns = [];
      this.questionComplete.forEach((question, index) => {
        const item = {
          title: `${question.questionType}题（${question.totalScore}分）`,
          align: 'center',
          children: [
            {
              title: '产品组',
              key: `${question.questionType}group${index}`,
              align: 'center',
              minWidth: 80,
            },
            {
              title: '题数',
              key: `${question.questionType}count${index}`,
              align: 'center',
              minWidth: 80,
            },
          ],
        };

        this.columns.push(item);
      });
    },
    setData() {
      this.data = [];

      const allKeys = [];
      this.questionComplete.forEach((question) => {
        allKeys.push(Object.keys(question.groupCodeMap));
      });

      let maxLen = 0;

      allKeys.forEach((keys) => {
        if (keys.length > maxLen) {
          maxLen = keys.length;
        }
      });

      for (let i = 0; i < maxLen; i += 1) {
        this.data.push({});
      }

      this.questionComplete.forEach((question, index) => {
        const keyGroup = `${question.questionType}group${index}`;
        const keyCount = `${question.questionType}count${index}`;

        const keys = Object.keys(question.groupCodeMap);
        keys.forEach((key, keyIndex) => {
          this.data[keyIndex][keyGroup] = key;
          this.data[keyIndex][keyCount] = question.groupCodeMap[key];
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.generate-test-paper-data-table {
  width: 100%;
}
</style>
